import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ChevronRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.5 3.5L10 8L5.5 12.5" stroke={color} />
    </svg>
  ),
)

ChevronRight.displayName = 'ChevronRight'

ChevronRight.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default ChevronRight
